import React, { Component } from 'react';
import Loading from '../../Loading.js'
import FormAutocomplete from '../../../Fields/FormAutocomplete.js';
import FormSelect from '../../../Fields/FormSelect.js';
import FormText from '../../../Fields/FormText.js';
import ControlExtranetUploads from './ControlExtranetUploads.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js';
import { getMessageTypes, getCreateMsgTitle } from '../../../Utilities/SnsExtranetFunctions.js';
import { getListProjectsCompact, getListCandidatesCompact, getProjectCandidatesCompact, getCandidateProjectsCompact, postMessage, getContacts } from '../../../Api/ExtranetActions.js';
import { getDocumentLabelsProject, getDocumentLabelsSignal, getDocumentLabelsCandidate } from '../../../Api/DocumentLabels.js';
import { isEmpty } from '../../../Utilities/JsonFunctions.js';

declare var globalSns;

class ControlMessageNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messageType: (this.props.contactId == null) ? 
                            (this.props.candidateId == null) ? 
                                (this.props.projectId == null ? 
                                    -1 // No candidate/project selected, we can choose
                                    : 2) // Project selected, use only messagetype 2
                                : 1 // Candidate selected, use only messagetype 1
                            : 0, // Contact selected, use only messagetype 0
            projectId: this.props.projectId,
            projectName: this.props.projectName,
            candidateId: this.props.candidateId,
            candidateName: this.props.candidateName,
            contactId: this.props.contactId == null ? -1 : this.props.contactId
        };

        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleMessageTypeChange = this.handleMessageTypeChange.bind(this);
        this.handleProjectChange = this.handleProjectChange.bind(this);
        this.handleCandidateChange = this.handleCandidateChange.bind(this);
        this.getValidationTextProject = this.getValidationTextProject.bind(this);
        this.getValidationTextCandidate = this.getValidationTextCandidate.bind(this);
        this.saveData = this.saveData.bind(this);
        this.saveDataOk = this.saveDataOk.bind(this);
    }

    componentWillMount() {
        this.loadDataDocumentLabelsAndContacts();
        this.loadData();
    }

    componentDidUpdate() {
        // Set the focus on appropriate control

        var text = document.getElementById("message");
        var projectId = document.getElementById("projectId");

        if (text == null || this.state.init != null)
            return;

        if (this.props.contactId != null) {
            text.focus();
            this.setState({init: true});
            return;
        }

        if (this.props.projectId != null) {
            text.focus();
            this.setState({init: true});
            return;
        }

        if (this.props.candidateId != null && this.state.projects.length > 1)  {
            projectId.focus();
            this.setState({init: true});
            return;            
        }

        if (this.props.candidateId != null && this.state.projects.length === 1) {
            text.focus();
            this.setState({init: true});
            return;            
        }            
    }

    loadData() {
        var dataProjects = [{"key": this.props.projectId, "value": this.props.projectName}]
        var dataCandidates = [{"key": this.props.candidateId, "value": this.props.candidateName}]
        
        if (this.props.projectId == null && this.props.candidateId == null) {
            // All projects&candidates are selectable
            getListProjectsCompact(globalSns.languageId, (data) => {
                this.setState({
                    projects: data,
                    filterprojects: data
                });
            });

            getListCandidatesCompact(globalSns.languageId, (data) => {
                this.setState({
                    candidates: data,
                    filtercandidates: data
                });
            });
        } else if (this.props.projectId != null && this.props.candidateId != null) {
            // No projects&candidates are selectable
            this.setState({
                projects: dataProjects,
                filterprojects: dataProjects,
                candidates: dataCandidates,
                filtercandidates: dataCandidates                
            });
        } else if (this.props.projectId != null) {
            // Only candidates (of project) are selectable
            this.setState({
                projects: dataProjects,
                filterprojects: dataProjects               
            });

            getProjectCandidatesCompact(this.props.projectId, globalSns.languageId, (data) => {
                this.setState({
                    candidates: data,
                    filtercandidates: data
                });                
            });            
        } else {
            // Only projects (of candidate) are selectable
            this.setState({
                candidates: dataCandidates,
                filtercandidates: dataCandidates                
            });

            getCandidateProjectsCompact(this.props.candidateId, globalSns.languageId, (data) => {
                var selectedProjectId = this.state.projectId;
                var selectedProjectName = this.state.projectName;
                
                if (data.length === 1) {
                    // Select the only available project
                    selectedProjectName = data[0].value;
                    selectedProjectId = data[0].key;
                }

                this.setState({
                    projects: data,
                    filterprojects: data,
                    projectId: selectedProjectId,
                    projectName: selectedProjectName
                });
            });            
        }
    }

    loadDataDocumentLabelsAndContacts() {
        getDocumentLabelsProject(globalSns.languageId, (data) => {
            this.setState({
                documentLabelsProject: data
            });
        });
        getDocumentLabelsSignal(globalSns.languageId, (data) => {
            this.setState({
                documentLabelsSignal: data
            });
        });                
        getDocumentLabelsCandidate(globalSns.languageId, (data) => {
            this.setState({
                documentLabelsCandidate: data
            });
        });
        getContacts((data) => {
            let contacts = [];
            for (let i = 0; i < data.length; i++) {
                let item = { key: data[i].seqPers, value: data[i].name + " " + data[i].firstName }
                contacts.push(item);
            }
            this.setState({
                contacts: contacts
            });
        });
    }

    saveData() {
        if (!this.isValid()) {
            this.setState({
                showInvalid: true
            });
            return;     
        }
        this.setState({
            saving: true
        });
        // Save message
        postMessage(globalSns.languageId, this.state.messageType, this.state.contactId, this.state.projectId, this.state.candidateId, this.state.message, (newData) => {
            if (newData == null) {
                this.setState({
                    showError: true
                });
            } else {
                // Save attachments to the historyId
                this.setState({
                    historyId : newData.historyId
                });
            }
        });   
    }

    saveDataOk() {
        // Save completed
        this.setState({
            showSaved: true
        });
        if (this.props.onRequestClose == null) {
            return;
        }
        setTimeout( () => {
            this.props.onRequestClose();
        }, 4000);
    }    

    getDocumentLabels() {
       switch(this.state.messageType) {
            case 0: return this.state.documentLabelsProject;
            case 1: return this.state.documentLabelsCandidate;
            case 2: return this.state.documentLabelsProject;
            case 3: return this.state.documentLabelsSignal;
            default: break;
        }
    }

    isValid() {
        if (this.state.messageType === -1 || isEmpty(this.state.message)) {
            return false;
        }

        if (this.state.messageType === 0 && this.state.contactId === -1) {
            return false;
        }

        if (this.state.messageType !== 0 && isEmpty(this.state.projectId)) {
            return false;
        }

        if (this.state.messageType === 1 && isEmpty(this.state.candidateId)) {
            return false;
        }

        if (this.state.messageType === 3 && !isEmpty(this.state.candidateId)) {
            return false;
        }

        return true;
    }

    getValidationTextProject() {
        if (!isEmpty(this.state.projectName) && isEmpty(this.state.projectId)) {
            return getTranslation("sns.general.extranet.newmessage.project.invalid")
        }

        if (this.state.messageType !== 0 && isEmpty(this.state.projectId)) {
            return getTranslation("basicform.erroremptyvalue");
        }

        return "";
    }
    
    getValidationTextCandidate() {
        if (!isEmpty(this.state.candidateName) && isEmpty(this.state.candidateId)) {
            return getTranslation("sns.general.extranet.newmessage.candidate.invalid")
        }

        if (this.state.messageType === 1 && isEmpty(this.state.candidateId)) {
            return getTranslation("basicform.erroremptyvalue");
        }

        return "";
    }

    handleValueChange(e) {
        var value = (e.target.type === "select-one") ? parseInt(e.target.value, 10) : e.target.value;
        this.setState({
            [e.target.id]: value
        });
    }

    handleMessageTypeChange(e) {
        var value = parseInt(e.target.value, 10);
        switch(value) {
            case 0:
                this.setState({
                    [e.target.id]: value
                });
                break;
            case 1:
                this.setState({
                    [e.target.id]: value,
                    contactId: this.props.contactId
                });
                break;
            default:
                this.setState({
                    [e.target.id]: value,
                    candidateId: this.props.candidateId,
                    candidateName: this.props.candidateName,
                    filterprojects: this.state.projects,
                    contactId: this.props.contactId
                });
        }
    }

    handleProjectChange(e, id) {
        if (e.target.value === this.state.projectName) {
            return;
        }

        if (id == null) {
            // set all candidates
            this.setState({
                projectId: id,
                projectName: e.target.value,
                filtercandidates: this.state.candidates
            });
        } else {
            getProjectCandidatesCompact(id, globalSns.languageId, (data) => {
                this.setState({
                    projectId: id,
                    projectName: e.target.value,
                    filtercandidates: data
                });                
            });
        }
    }

    handleCandidateChange(e, id) {
        if (e.target.value === this.state.candidateName) {
            return;
        }

        if (id == null) {
            // set all projects
            this.setState({
                candidateId: id,
                candidateName: e.target.value,
                filterprojects: this.state.projects
            });
        } else {
            getCandidateProjectsCompact(id, globalSns.languageId, (data) => {
                var selectedProjectName = this.state.projectName;
                var selectedProjectId = this.state.projectId;
                
                if (data.length === 1) {
                    // Select the only available project
                    selectedProjectName = data[0].value;
                    selectedProjectId = data[0].key;

                    // Re-filter the available candiddates because the project has been set
                    getProjectCandidatesCompact(selectedProjectId, globalSns.languageId, (data) => {
                        this.setState({
                            filtercandidates: data
                        });                
                    });
                }

                this.setState({
                    candidateId: id,
                    candidateName: e.target.value,
                    filterprojects: data,
                    projectId: selectedProjectId,
                    projectName: selectedProjectName
                });
            });
        }
    }

    render() {
        if (this.state.filterprojects == null || this.state.filtercandidates == null ||
            this.state.documentLabelsCandidate == null || this.state.documentLabelsProject == null || this.state.documentLabelsSignal == null || this.state.contacts == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div>
                <h2 className="btn btn-primary">
                    {getCreateMsgTitle(this.props.candidateId, this.props.projectId)}
                </h2>
                {
                    (this.state.showError) ?
                        <span className="ErrorLabel">{getTranslation("sns.general.error")}</span> : ""
                }
                {
                    (this.state.showInvalid) ?
                        <span className="ErrorLabel">{getTranslation("general.errorvalidationerror")}</span> : ""
                }                
                {
                    (this.state.showSaved) ?
                        <span className="SuccessLabel">{getTranslation("sns.general.saved")}</span> : ""
                }
                <div className="EditingFormTable table">
                    {
                        (this.props.candidateId == null && this.props.projectId == null && this.props.contactId == null) ?
                            <FormSelect id="messageType"
                                text={getTranslation("sns.general.extranet.messagetype")}
                                required={true}
                                emptyValue={getTranslation("sns.general.ddlnovalue")}
                                data={getMessageTypes(true)}
                                showValidation={this.state.showInvalid}
                                validationText={this.state.messageType === -1 ? getTranslation("basicform.erroremptyvalue") : ""} 
                                value={this.state.messageType}
                                onChange={this.handleMessageTypeChange} /> : ""
                    }
                    {
                        (this.state.messageType === 0) ?
                            <FormSelect id="contactId"
                                text={getTranslation("sns.general.extranet.contact")}
                                required={true}
                                emptyValue={getTranslation("sns.general.ddlnovalue")}
                                data={this.state.contacts}
                                showValidation={this.state.showInvalid}
                                validationText={this.state.contactId === -1 ? getTranslation("basicform.erroremptyvalue") : ""}
                                readonly={this.props.contactId != null}
                                value={this.state.contactId}
                                onChange={this.handleValueChange} /> : ""                           
                    }                    
                    <div className="tr">
                        <div className="FieldLabel td">
                            <label htmlFor="projectId">{getTranslation("sns.general.extranet.project")}</label>
                            {
                                (this.state.messageType !== 0) ? <span className="required-mark">*</span> : ""
                            }
                        </div>
                        <FormAutocomplete id="projectId"
                            showValidation={this.state.showInvalid}
                            validationText={this.getValidationTextProject()} 
                            readonly={this.props.projectId != null || (this.props.candidateId !== null && this.state.projects.length === 1)}
                            value={this.state.projectId}
                            data={this.state.filterprojects}
                            onChange={this.handleProjectChange} /> 
                    </div>
                    {
                        ([0,1].includes(this.state.messageType)) ?
                            <div className="tr">
                                <div className="FieldLabel td">
                                    <label htmlFor="candidateId">{getTranslation("sns.general.extranet.uploader.candidate")}</label>
                                    {
                                        (this.state.messageType === 1) ? <span className="required-mark">*</span> : ""
                                    }
                                </div>
                                <FormAutocomplete id="candidateId"
                                    showValidation={this.state.showInvalid}
                                    validationText={this.getValidationTextCandidate()}
                                    readonly={this.props.candidateId != null}                      
                                    value={this.state.candidateId}
                                    data={this.state.filtercandidates}
                                    onChange={this.handleCandidateChange} /> 
                            </div> : ""
                    }
                    <FormText id="message" rows={5}
                        className="fontawesome"
                        text="" // Font Awesome fa-pencil
                        required={true}
                        showValidation={this.state.showInvalid}
                        validationText={isEmpty(this.state.message) ? getTranslation("basicform.erroremptyvalue") : ""}                         
                        value={this.state.message}
                        onChange={this.handleValueChange} />
                    <ControlExtranetUploads
                        documentLabels={this.getDocumentLabels()} 
                        historyId={this.state.historyId} 
                        onSaved={this.saveDataOk} />                         
                    {
                        (this.state.saving) ? "" :
                            <div className="tr text-right col-sm-8 button-wrapper">
                                <input type="button" id="cancel"
                                    className="FormButton btn btn-primary transparent"
                                    value={getTranslation("sns.general.cancel")}
                                    onClick={() => this.props.onRequestClose()} />
                                <input type="button" id="save"
                                    className="FormButton btn btn-primary blue"
                                    value={getTranslation("sns.forms.submit")}
                                    onClick={this.saveData} />
                            </div>
                    }
                </div>                
            </div>
        );
    }
}

export default ControlMessageNew;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlMessageNew.js